import React, { useContext, useEffect, useState } from 'react';
import QRCode from 'qrcode.react';
import Page from '../../layout/Page';
import Card from '../../layout/Card';
import styled from 'styled-components';
import AuctionSelect from '../../components/auction/AuctionSelect';
import { useHistory } from 'react-router-dom';
import PNTrading from 'src/pn-trading-sdk';
import { formatPrice, getAuctionMetaValue, getPaymentGroup, getPaymentType } from '../../utils/Util';
import Objects from '../../utils/api/Objects';
import Table from '../../components/Table';
import { sortByWinningUser } from './TickOff';
import { Link } from 'react-router-dom';

export default function PageAuctionLabels(props) {
	let id = props.match.params.id;

	const [objects, setObjects] = useState();

	useEffect(() => {
		PNTrading.get(`/auctions/${id}/objects?limit=10000&embed=true&noCache=true`).then((oresp) => {
			setObjects(oresp.data);
		});
	}, [id]);

	if (!objects)
		return (
			<div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<div className="loader"></div>
			</div>
		);

	return (
		<Style>
			<Card size="medium" className="hide-print">
				<h2>Etikettlista</h2>
				<h5>(denna ruta visas inte vid utskrift)</h5>
				<div className="spacer s"></div>
				<p>Denna sida kan skrivas ut direkt i webbläsaren, antingen som en PDF eller via skrivare. Summeringen baseras på inbetalningar och avprickade objekt.</p>
				<div className="spacer s"></div>
				<button onClick={() => window.print()}>Skriv ut</button>
			</Card>

			<Card size="full" className="page-wrapper">
				{new Array(Math.ceil(objects.length / 14)).fill(0).map((_, i) => {
					return (
						<div className="a4-page">
							{objects
								.filter((_, oi) => oi >= i * 14 && oi < (i + 1) * 14)
								.map((object) => {
									return (
										<div className="object" key={object.id}>
											<div className="content">
												<div className="id">
													{object.position} / {object.id}
												</div>
												<div className="title">{object.title}</div>
											</div>
											<div className="qr">
												<QRCode value={`https://riksauktioner.se/objekt/${object.id}?source=qr-label`} size={256} />
												<img src="/ra-logga-invoice.png" alt="" />
											</div>
										</div>
									);
								})}
						</div>
					);
				})}
			</Card>
		</Style>
	);
}

const Style = styled(Page)`
	.page-wrapper {
		background-color: transparent;
		box-shadow: none;
	}

	.a4-page {
		width: 21cm;
		min-height: 29.6cm;
		padding: 5mm;
		margin-bottom: 2rem;
		background: white;

		.object {
			width: 50%;
			float: left;
			padding: 10px;
			padding-right: 15px;
			height: 154.5px;
			display: flex;

			.content {
				flex-grow: 1;
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;

				.id {
					font-size: 20px;
					font-weight: bold;
				}

				.title {
					font-size: 14px;
				}
			}

			.qr {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				canvas {
					width: 60% !important;
					height: unset !important;
					aspect-ratio: 1/1 !important;
				}

				img {
					align-self: flex-end;
					justify-self: flex-end;
					margin-top: auto;
					width: 140px;
				}
			}
		}
	}

	@media print {
		padding: 0;

		.a4-page {
			margin-bottom: 0;
		}
	}
`;
